<template>
  <div v-if="active" class="support-access-banner" :class="urgencyClass">
    <div class="support-access-banner__inner">
      <div class="support-access-banner__text">
        <strong>Support Access</strong>
        — acting as <strong>{{ clientName }}</strong>
        <span v-if="actorEmail"> (started by {{ actorEmail }})</span>
        <span v-if="reason"> — {{ reason }}</span>
      </div>
      <div class="support-access-banner__timer" :title="expiresAt">
        Time left: {{ formattedRemaining }}
      </div>
      <button type="button" class="btn btn-sm btn-light support-access-banner__end" @click="endSupport">
        End support
      </button>
    </div>
  </div>
</template>

<script>
import * as Cookies from 'js-cookie';
import { endSupportAccess } from '@/api/request/support';

export default {
  name: 'SupportAccessBanner',
  data() {
    return {
      active: false,
      clientName: '',
      actorEmail: '',
      reason: '',
      expiresAt: '',
      supportLogId: '',
      remainingMs: 0,
      tickHandle: null,
    };
  },
  computed: {
    formattedRemaining() {
      const totalSec = Math.max(0, Math.floor(this.remainingMs / 1000));
      const m = Math.floor(totalSec / 60);
      const s = totalSec % 60;
      return `${m}:${String(s).padStart(2, '0')}`;
    },
    urgencyClass() {
      const mins = this.remainingMs / 60000;
      if (mins <= 3) return 'support-access-banner--red';
      if (mins <= 15) return 'support-access-banner--orange';
      return 'support-access-banner--green';
    },
  },
  mounted() {
    this.hydrateFromCookies();
    this.tickHandle = setInterval(this.tick, 1000);
  },
  beforeDestroy() {
    if (this.tickHandle) clearInterval(this.tickHandle);
  },
  methods: {
    hydrateFromCookies() {
      if (Cookies.get('supportMode') !== '1') {
        this.active = false;
        return;
      }
      this.active = true;
      this.clientName = Cookies.get('supportClientName') || 'channel';
      this.actorEmail = Cookies.get('supportActorEmail') || '';
      this.reason = Cookies.get('supportReason') || '';
      this.expiresAt = Cookies.get('supportExpiresAt') || '';
      this.supportLogId = Cookies.get('supportLogId') || '';
      this.tick();
    },
    tick() {
      if (!this.active || !this.expiresAt) return;
      const ends = Date.parse(this.expiresAt);
      if (Number.isNaN(ends)) return;
      this.remainingMs = ends - Date.now();
      if (this.remainingMs <= 0) {
        this.forceEnd('Support Access session expired. Please sign in again.');
      }
    },
    async endSupport() {
      await this.forceEnd(null);
    },
    async forceEnd(message) {
      const token = Cookies.get('user-token');
      const logId = this.supportLogId || Cookies.get('supportLogId');
      try {
        if (token && logId) {
          await endSupportAccess(token, logId);
        }
      } catch (e) {
        console.warn('support end log failed', e);
      }
      if (this.tickHandle) {
        clearInterval(this.tickHandle);
        this.tickHandle = null;
      }
      this.active = false;
      [
        'supportMode',
        'supportClientName',
        'supportActorEmail',
        'supportReason',
        'supportExpiresAt',
        'supportLogId',
      ].forEach((key) => Cookies.remove(key));
      await this.$store.dispatch('auth/AUTH_LOGOUT');
      if (message) {
        this.$router.push({ path: '/login', query: { supportEnded: '1', msg: message } });
      } else {
        this.$router.push('/login');
      }
    },
  },
};
</script>

<style scoped>
.support-access-banner {
  position: sticky;
  top: 0;
  z-index: 1050;
  color: #fff;
  font-size: 13px;
}
.support-access-banner__inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
}
.support-access-banner__text {
  flex: 1 1 240px;
}
.support-access-banner__timer {
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}
.support-access-banner--green {
  background: #1e7e34;
}
.support-access-banner--orange {
  background: #c77c02;
}
.support-access-banner--red {
  background: #b71c1c;
}
</style>
